<template>
  <div class="privacy-policy">
    <h1>“大有阳光”软件许可及用户服务协议</h1>
    <p class="update-date">更新日期：{{ updateDate }}</p>
    <p class="effective-date">生效日期：{{ effectiveDate }}</p>

    <h2>导言:</h2>
    <p>
      欢迎使用“大有阳光”软件及相关服务！
    </p>
    <p>
      为使用“大有阳光”软件（以下简称“本软件”）及服务，请您在开始使用本软件及相关服务之前，认真阅读并充分理解《“大有阳光”软件许可及用户服务协议》（以下简称“本协议”），<b
        >特别是涉及免除或者限制责任的条款以及权利许可、知识产权、法律适用和争议解决条款等。其中，免除或者限制责任条款等重要内容可能以加粗形式提示您注意，您应重点阅读。</b
      >
    </p>
    <p>
      您<b>勾选“已阅读并同意全部条款”并点击“同意”</b>后，即视为已充分阅读、理解并承诺遵守全部条款，本协议对双方具有法律约束力。如您不同意本协议，这将导致我们无法为您提供完整的产品和服务，您也可以选择停止使用。除非您已阅读并接受本协议所有条款，否则您无权注册、登录或使用本协议及相关服务。您的注册、登录、使用等行为即视为您已充分理解本协议，并同意作为本协议的一方当事人接受本协议以及其他与本软件及相关服务相关的协议和规则（包括但不限于《隐私保护政策》等）的约束。
    </p>
    <p>
      如果您
      <b>未满18周岁</b>
      ，请在法定监护人的陪同下阅读本协议及上述其他协议，并特别注意未成年人使用条款。未成年人用户注册或使用本服务前，需通过法定监护人签署《软件使用知情同意书》。
    </p>
    <h2>一、协议的范围</h2>
    <p>1.协议适用主体范围</p>
    <p>
      本协议是您与广州大有网络科技有限公司（以下简称“本公司”）之间关于注册、登录、使用本公司开发的“大有阳光”软件（以下简称“本软件”）及相关服务所订立的法律协议。
    </p>
    <p>2.协议关系及冲突条款</p>
    <p>
      本协议包括正文及以下附属文件，共同构成完整法律文件：
    </p>

    <p>《隐私保护政策》</p>

    <p>用户可通过本软件【我的 - 设置】页面随时查阅本协议及上述附属文件。</p>

    <p>
      如附属文件与本协议冲突，以本协议为准；如附属文件间冲突，以最新修订版本为准。
    </p>

    <p>
      本协议内容同时包括本公司可能不断更新并发布的关于本服务的相关协议、业务规则等内容。上述内容一经正式发布，即为本协议不可分割的组成部分，您同样应当遵守。
    </p>
    <p>3.适用范围</p>
    <p>
      本协议适用于本软件提供的全部功能与服务，包括但不限于：账号注册登录、趣味测评（“测测”）、专业测评、房树人测评、普测任务作答、轻干预大模型（“聊聊”）、心理课程及直播类服务等。
    </p>
    <h2>二、定义与解释</h2>
    <p>1.关键术语</p>
    <p>
      本软件：指本公司开发的“大有阳光”软件及其关联程序、服务接口。
    </p>
    <p>
      用户内容：指您通过本软件上传、发布、存储的文字、图片、音视频、测评数据等。
    </p>
    <p>
      虚拟产品：包括课程激活码等数字化服务。
    </p>
    <p>
      轻干预大模型（“聊聊”）：指基于人工智能技术提供的心理对话、心理分析、建议生成等服务。
    </p>
    <p>2.法律依据</p>
    <p>
      本协议依据《中华人民共和国民法典》《中华人民共和国网络安全法》《中华人民共和国个人信息保护法》《中华人民共和国未成年人保护法》《中华人民共和国电子商务法》等法律法规制定。
    </p>

    <h2>三、本软件及相关服务</h2>
    <p>
      1.
      本软件部分相关服务系基于算法模型或生成式人工智能模型提供，并可能同时依托于其他模型、服务，以向您提供优质的心理分析或建议服务。
    </p>
    <p>
      2.本软件输出的全部内容（包括测评结果、对话建议、课程素材等）仅供您个人非商业用途参考，您不得将输出的内容用于商业用途或其他目的。若您擅自将本服务内容用于商业用途或其他目的，本公司有权终止服务并要求您赔偿损失。
    </p>
    <p>
      3.如涉及对您或相关方可能会产生重大影响的情形，建议您咨询专业心理机构或人士，本软件的输出内容不应成为您进一步作为或不作为的依据。
    </p>
    <p>
      4.服务内容：
    </p>
    <ul>
      <li>
        <p>
          （1）测评服务：趣味测评、专业测评、房树人测评等结果均基于心理学量表计算规则或专业理论得出，仅供参考，不构成医学诊断、心理诊断或法律证据。您应知悉测评结果可能因个体差异、作答状态等因素存在偏差，需结合专业意见使用，本公司不保证其完全准确性及作为法律证据的效力。
        </p>
      </li>
      <li>
        <p>
          （2）轻干预大模型（“聊聊”）服务：本服务基于自主研发的“轻干预心理咨询大模型”，底座采用国产大型语言模型（Qwen系列等），并结合自建心理咨询语料进行微调，配置8卡RTX4090×2 服务器集群作为训练算力平台，支持分布式并行训练。
        </p>
        <p>模型通过使用高质量心理咨询对话语料（涵盖SFBT、CBT等六类心理疗法），采用监督微调+GRPO（近似强化学习）在内的多种方法进行训练。模型内置情绪识别、意图理解、安全过滤等模块，可根据用户输入动态生成干预策略（包括情绪缓解、目标澄清、资源引导等），同时采用多层安全策略，避免生成危险、有害或误导性内容。</p>
        <b>

        <p>此服务也具有一定的局限性。首先，本模型属于“轻干预”心理支持系统，仅提供情绪陪伴、基本心理支持建议与对话引导，不具备临床诊断、精神疾病治疗资质和能力，不能替代专业心理咨询师或医疗机构的专业服务。其次，由于大语言模型基于概率生成机制，可能在极少数场景出现不准确、不完整或与实际情境不完全相符的回答，您应结合自身判断使用。对高风险问题（如自伤、自杀倾向、暴力倾向、严重心理危机等），本模型无法提供全面可靠建议，您应立即寻求专业医疗机构帮助或拨打心理危机干预热线，必要时联系公安机关。最后，当前版本主要面向青少年/家长/教师心理支持与一般心理咨询场景。对于严重情绪障碍、严重心理危机、精神疾病等情形，不适用本服务。</p>
        </b>
        <b>
          <p>禁止输入诱导生成违法、暴力、歧视性等违规内容，禁止利用本服务输出数据训练竞争模型或从事其他侵犯本公司知识产权的行为。</p>
        </b>
      </li>
      <li>
        <p>
          （3）心理课程与直播服务：课程及直播内容等版权均归本公司或授权方所有，您仅享有个人非商业性使用权，禁止未经授权进行录播、截屏、传播、转售或用于商业培训等侵权行为。
        </p>
      </li>
    </ul>
    <h2>四、软件许可与使用限制</h2>
    <p>1.许可范围</p>
    <p>
      本公司授予您可撤销、非独占、不可转让、有限的个人使用许可，仅限于在合法终端设备上安装、运行本软件，禁止以下行为：
    </p>
    <p>反向工程、反编译、破解软件技术架构；</p>
    <p>出租、出借、销售软件或利用软件从事营利活动；</p>
    <p>通过非官方渠道获取、修改软件代码或数据。</p>
    <p>
      本协议未明示授权的其他一切权利仍由本公司保留，您在行使该些权利前须另行获得本公司的书面许可，同时本公司如未行使前述任何权利，并不构成对该权利的放弃。
    </p>
    <p>2.软件更新与终止</p>
    <p>
      本公司有权不经通知对软件进行功能性更新或安全补丁推送，旧版本可能停止服务；
    </p>
    <p>
      若您存在实质性违反本协议的行为（包括但不限于反向工程、数据爬取、违法内容传播），或存在以下重大违约情形之一：例如恶意攻击系统、侵犯知识产权或违反法律规定的行为，本公司可单方终止许可，并保留追究法律责任的权利。
    </p>

    <h2>五、关于账号</h2>
    <p>
      1.本软件账号可通过手机号码进行注册，并绑定注册手机号码，同时并自行设置符合安全要求的密码。您设置的账号、密码、收到的验证码，是您用以登录并以注册您的用户身份使用本软件及相关服务的凭证。或者您可以通过已有的微信账号、QQ号码辅助注册账号。在符合平台规则的前提下，您可以更换绑定的手机号码。
    </p>
    本公司有权根据用户需求或产品需要对账号注册和绑定的方式进行变更。
    <p>
      2.本软件账号的所有权归本公司所有，用户完成申请注册手续后，仅获得本软件账号的使用权，且该使用权仅属于初始申请注册人。同时，初始申请注册人不得赠与、借用、租用、转让或售卖账号或者以其他方式许可非初始申请注册人使用账号。非初始申请注册人不得通过受赠、继承、承租、受让或者其他任何方式使用账号。
    </p>
    <p>
      3.您有责任妥善保管注册账号信息、账号密码、验证码的安全，并对注册账户以及密码下的行为承担法律责任，包括但不限于您在本软件及相关服务上进行的任何数据修改、言论发表等操作行为可能引起的一切法律责任。您应高度重视对账号、密码、验证码的保密，在任何情况下不向他人透露。若发现他人未经许可使用您的账号或发生其他任何安全漏洞问题时，您应当立即通知本公司。
    </p>
    <p>
      4.在注册、使用和管理账号时，您应保证注册账号时所填写身份信息的真实性，请您在注册、管理账号时使用合法、有效的信息（包括您的昵称、性别以及手机号码等）。若您提交的材料或提供的信息不规范或公司有理由怀疑为错误、不实、不合法的资料，则本公司有权拒绝为您提供相关功能，您可能无法使用本软件及相关服务或在使用过程中部分功能受到限制。
    </p>
    <p>
      5.您理解并同意，为避免资源浪费，如果您在注册账号后连续180日未登录该账号使用，本公司将通过短信、邮件、站内信等方式至少提前30日通知您账号回收风险。经通知后30日内仍未登录的，本公司有权回收账号并清除数据，且不承担数据恢复义务，由此带来的任何损失均由您自行承担。账号回收后，历史行为责任（如侵权、违约）仍由您承担。
    </p>
    <p>
      6.账号注销
    </p>
    <p>
      在需要终止使用本软件账号服务时，符合以下条件的：
    </p>
    <ul>
      <li>
        <p>
          （1）您仅能申请注销您本人的账号，并依照本软件的流程进行注销；
        </p>
      </li>
      <li>
        <p>
          （2）您仍应对您在注销账号前且使用本软件及相关服务期间的行为承担相应责任；
        </p>
      </li>
      <li>
        <p>
          （3）注销成功后，账号记录、功能等将无法恢复或提供。
        </p>
      </li>
    </ul>
    <p>
      如您需要注销您的账号，您可以通过拨打本软件客服电话来申请注销您的账号，账号注销的处理期限原则上为5个工作日。
    </p>
    <h2>六、用户行为规范</h2>
    <p>
      1.您应当对您使用本软件及相关服务的行为负责，除非法律允许或者经公司事先书面许可，您使用本软件及相关服务不得具有下列行为：
    </p>
    <ul>
      <li>
        <p>
          （1）冒充他人身份、伪造测评数据或干扰服务正常运行；
        </p>
      </li>
      <li>
        <p>
          （2）利用技术手段批量注册账号、爬取数据或进行流量攻击；
        </p>
      </li>
      <li>
        <p>
          （3）恶意注册本软件及相关服务的账号，包括但不限于频繁、批量注册账号；
        </p>
      </li>
      <li>
        <p>
          （4）违反法律法规、本协议、公司的相关规则及侵犯他人合法权益的其他行为。
        </p>
      </li>
    </ul>
    <p>
      2.您输入、输出/生成、制作、评论、上传、发布、传播的信息应自觉遵守法律、行政法规，遵守公共秩序，尊重社会公德和伦理道德、社会主义核心价值观、国家利益，尊重他人合法权益、道德风尚和信息真实性等“七条底线”要求，否则本公司有权立即采取相应处理措施。您不得自行或允许、协助任何人利用本软件及相关服务从事下述行为：
    </p>
    <ul>
      <li>
        <p>
          （1）反对宪法确定的基本原则的；
        </p>
      </li>
      <li>
        <p>
          （2）危害国家安全和利益，泄露国家秘密的；
        </p>
      </li>
      <li>
        <p>
          （3）颠覆国家政权、推翻社会主义制度、损害国家形象、煽动分裂国家、破坏国家统一和社会稳定的；
        </p>
      </li>
      <li>
        <p>
          （4）损害国家荣誉和利益的；
        </p>
      </li>
      <li>
        <p>
          （5）宣扬恐怖主义、极端主义的；
        </p>
      </li>
      <li>
        <p>
          （6）宣扬民族仇恨、破坏民族团结的；
        </p>
      </li>
      <li>
        <p>
          （7）破坏国家宗教政策、宣扬邪教和封建迷信的；
        </p>
      </li>
      <li>
        <p>
          （8）编造、散布谣言、虚假信息，扰乱经济秩序和社会秩序，破坏社会稳定的；
        </p>
      </li>
      <li>
        <p>
          （9）散布、传播、宣扬暴力、淫秽、色情、露骨、赌博、凶杀、恐怖或者教唆犯罪的；
        </p>
      </li>
      <li>
        <p>
          （10）利用、伤害或企图利用或伤害未成年人，损害未成年人身心健康，侵害未成年人合法权益的；
        </p>
      </li>
      <li>
        <p>
          （11）侮辱、诽谤、冒犯、辱骂、激怒他人，欺凌或控制他人，侵害他人合法权益的；
        </p>
      </li>
      <li>
        <p>
          （12）对他人进行暴力恐吓、威胁，实施人肉搜索的；
        </p>
      </li>
      <li>
        <p>
          （13）涉及他人隐私、个人信息或资料的；
        </p>
      </li>
      <li>
        <p>
          （14）散布污言秽语，损害社会公序良俗的；
        </p>
      </li>
      <li>
        <p>
          （15）侵害商业秘密，侵犯他人隐私权、名誉权、荣誉权、肖像权、知识产权等合法权益内容的；
        </p>
      </li>
      <li>
        <p>
          （16）其他违反法律法规、政策及公序良俗，干扰本软件及相关服务正常运营或侵犯其他用户或第三方合法权益内容的行为。
        </p>
      </li>
    </ul>
    <h2>七、个人信息与隐私保护</h2>
    <p>
      1. 信息类型与用途
    </p>
    <table>
      <thead>
        <tr>
          <th>信息类别</th>
          <th>收集目的</th>
          <th>共享范围</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>身份信息（手机号码、IP地址等）</td>
          <td>账号注册、身份核验、服务身份识别</td>
          <td>本公司仅在司法机关、行政机关依法出具协查通知的情况下提供；不向第三方随意共享</td>
        </tr>
        <tr>
          <td>测评数据与行为日志</td>
          <td>服务优化、个性化推荐、用户体验提升</td>
          <td>经脱敏处理（去除可识别个人身份的信息）后用于学术研究</td>
        </tr>
        <tr>
          <td>设备信息（IP、MAC地址）</td>
          <td>风险控制、反作弊检测、保障服务安全</td>
          <td>委托第三方安全服务商处理</td>
        </tr>
        <tr>
          <td>聊聊大模型（用户在对话中主动输入的文本内容、基于文本提取的匿名特征）</td>
          <td>实现心理咨询支持功能、提升模型质量与优化算法、风险识别与安全审计、服务运行维护</td>
          <td>实现心理咨询支持功能、提升模型质量与优化算法、风险识别与安全审计、服务运行维护</td>
        </tr>
      </tbody>
    </table>
    <p>
      2. 数据安全措施
    </p>
    <ul>
      <li>
        <p>
          （1）在信息传输层进行SSL加密传输，保障敏感数据传输的不可解密性；
        </p>
      </li>
      <li>
        <p>
          （2）进行数据脱敏（测评报告中的敏感字段（如姓名、联系方式）将替换为不可逆哈希值，确保无法通过技术手段还原；聊聊（轻干预大模型）所有对话内容将进行匿名化存储，不用于识别特定用户身份，仅用于模型改进与安全监测，不会对外披露）；
        </p>
      </li>
      <li>
        <p>
          （3）定期进行数据的巡查，审查数据收集、存储及处理流程是否合规；
        </p>
      </li>
      <li>
        <p>
          （4）严格限制内部人员对敏感数据的访问权限，实行最小必要的权限原则；
        </p>
      </li>
      <li>
        <p>
          （5）定期执行安全审计工作；
        </p>
      </li>
      <li>
        <p>
          （6）管理措施：与员工签订保密协议并定期对员工进行数据安全与隐私保护培训与考核；
        </p>
      </li>
      <li>
        <p>
          （7）建立数据的应急机制预案，如发现数据泄露风险，在24小时内完成迅速解决并通知受影响用户；
        </p>
      </li>
      <li>
        <p>
          （8）严格控制第三方服务的安全性内容；
        </p>
      </li>
    </ul>
    <p>3. 用户权利</p>
    <p>
      您可通过本软件【我的】页面相关功能模块行使以下权利，本公司将在法律法规规定的期限内响应您的请求：
    </p>
    <ul>
      <li>
        <p>
          （1）查询、更正、删除您的个人信息；
        </p>
      </li>
      <li>
        <p>
          （2）撤回数据收集授权（撤回授权后可能影响部分服务的正常使用）；
        </p>
      </li>
      <li>
        <p>
          （3）获取个人信息副本（法律法规允许范围内）；
        </p>
      </li>
      <li>
        <p>
          （4）若您认为本公司收集、使用您个人信息的行为违反法律法规或本协议约定，可向客服提出异议并要求纠正。
        </p>
      </li>
    </ul>  

    <h2>八、付费服务与虚拟产品规则</h2>
    <p>
      1.本软件的各项付费服务现仅能使用激活码兑换使用。若因技术故障导致服务无法正常使用，您可申请退回激活码；其他情形下，激活码一经成功使用（兑换相应服务），不予退回。
    </p>
    <p>
      2.您理解并同意，激活码的获取与本平台无关，无论您从何处获得激活码，本平台均不不承担除技术故障外的退费义务。因激活码本身产生的纠纷（如购买欺诈、失效等），请您与激活码提供方协商解决。
    </p>
    <h2>九、知识产权</h2>
    <p>
      1.本公司是本软件的知识产权权利人。本软件的一切著作权、商标权、专利权、商业秘密等知识产权，以及与本软件相关的所有信息内容（包括但不限于文字、图片、音频、视频、图表、程序代码、界面设计、版面框架、有关数据或电子文档、课程内容、测评信息、算法模型等）均受中华人民共和国法律法规和相应的国际条约保护，本公司享有上述知识产权，但相关权利人依照法律规定应享有的权利除外。未经本公司许可，任何人不得擅自使用本软件及相关服务中的内容（包括但不限于改编、复制、传播、爬虫、垂直搜索、镜像或交易等）。
    </p>
    <p>
      2.您理解并同意，您使用本软件及相关服务过程中上传、发布的全部内容归属于您，均不因为上传、发布行为对自己的内容所拥有的权利发生任何改变。您发布的内容（如评论、测评结果等）默认授予本公司和/或关联方一项全球范围内的、免费的、永久的、可转让的、非独占使用权，在法律允许的范围内使用您的内容，仅限于服务运营、改进及技术处理，包括但不限于存储、展示、脱敏分析及算法优化。您可通过书面通知要求本公司停止使用其内容，但已完成的脱敏分析及算法优化数据除外。您承诺不主张署名权、修改权等著作人身权。
    </p>
    <p>
      3.您理解并承诺，您上传、发布的内容均应为您享有知识产权或已获取权利人合法授权的内容，不存在任何违反适用的法律法规、侵犯他人合法权益（包括但不限于著作权、专利权、商标权等知识产权及人格权、个人信息权益等其他权益）、违反公序良俗的内容，否则您应自行承担全部法律责任，给本公司造成损失的，您应予以赔偿。
    </p>
    <h2>十、免责声明</h2>
    <p>
      1.因不可抗力（如自然灾害、政府行为等法定不可抗力情形）导致的服务中断，本公司不承担责任。
    </p>
    <p>
      2.您依赖APP中的测评结果、对话建议结果或课程、直播等内容作出的决策需自行承担风险，本公司不保证其适用性。
    </p>
    <p>
      3.本软件可能包含第三方链接、广告或服务，其内容与责任由第三方独立承担。本公司尽合理努力进行初步筛查，但明知或应知第三方服务违法时，保留采取措施避免用户利益受损的权利。用户因使用第三方链接遭受损失的，应在发现损失后24小时内向本公司提交书面通知，否则视为放弃索赔权利。您与第三方间的纠纷需自行解决，与本公司无关。
    </p>

    <h2>十一、违约责任</h2>
    <p>
      1.若您违反本协议或其他服务条款，本公司有权采取以下措施：
    </p>
    <p>
      （1）删除违规内容、限制功能、封禁账号等；
    </p>
    <p>
      （2）冻结虚拟资产、追偿经济损失（包括律师费、取证费等维权成本）；  
    </p>
    <p>（3）向监管部门举报或移交司法机关处理。</p>
    <p>
      对于因此而造成您无法正常使用账号及相关服务、无法正常获取您账号内资产或其他权益等后果，本公司不承担任何责任。
    </p>
    <p>
      2.因您违反本协议或其他服务条款规定，引起第三方投诉或诉讼索赔的，您应当自行承担全部法律责任。因您的违法或违约行为导致本公司及其关联公司、控制公司向任何第三方赔偿或遭受国家机关处罚的，您还应足额赔偿本公司及其关联公司、控制公司因此遭受的全部损失（包括但不限于直接损失以及因维权产生的律师费、差旅费、诉讼费、保函费等间接损失）。
    </p>
    <h2>十二、未成年人特别条款</h2>
    <p>
      1.若您是未满18周岁的未成年人，应在监护人监护、指导并获得监护人同意情况下阅读本协议和使用本软件及相关服务。
    </p>
    <p>
      2.本公司重视对未成年人个人信息的保护，未成年用户在填写个人信息时，请加强个人保护意识并谨慎对待，并应当在取得监护人的同意以及在监护人指导下正确使用本软件及相关服务。
    </p>
    <p>
      3.未成年人用户及其监护人理解并确认，如您违反法律法规、本协议内容，则您及您的监护人应依照法律规定承担因此而可能导致的全部法律责任。
    </p>
    <p>
      4.未成年人用户特别提示
    </p>
    <p>
      未成年人使用本软件及相关服务应在其监护人的监督指导下，在合理范围内正确学习使用网络，避免沉迷虚拟的网络空间，影响日常的学习生活，养成良好上网习惯。未成年人用户及监护人在使用本软件及相关服务时应必须遵守《全国青少年网络文明公约》：要善于网上学习，不浏览不良信息。要诚实友好交流，不侮辱欺诈他人。要增强自护意识，不随意约会网友。要维护网络安全，不破坏网络秩序。要有益身心健康，不沉溺虚拟时空。
    </p>
    <p>
      5.为更好地保护未成年人隐私权益，本公司特别提醒您<b>慎重发布包含未成年人素材的内容</b>，一经发布，即视为您已获得权利人同意在本软件及相关服务展示未成年人的肖像、声音等信息，且允许本公司依据本协议使用、处理等与该未成年人相关的内容。如权利人通知本公司您发布的内容侵犯未成年人权利、出于保护权利人及未成年人权利的考虑，本公司有权对您发布的内容进行处理并通知您。
    </p>
    <p>
      6.监护人特别提示
    </p>
    <p>
      未成年人用户需提供监护人身份证明及同意书（见《软件使用知情同意书》）。法定监护人应指导子女上网应该注意的安全问题，防患于未然。如您的被监护人使用本软件及相关服务的，您作为监护人应指导并监督被监护人的注册和使用行为，如您的被监护人申请注册本账号，本公司将有权认为其已取得您的同意。
    </p>
    <h2>十三、争议解决与法律适用</h2>
    <p>
      双方应共同遵守本协议的内容，发生纠纷的，应友好协商，协商不成的，双方均有权向广州市天河区人民法院提起诉讼解决，并适用中华人民共和国法律。
    </p>
    <h2>十四、其他条款</h2>
    <p>
      1.通知送达
    </p>
    <p>
      本公司通过APP公告、站内信或绑定手机短信向您发送通知，发送之日即视为送达之日。您应及时关注相关通知内容，因未及时查看通知产生的损失，由您自行承担。
    </p>
    <p>
      2.协议变更
    </p>
    <p>
      本公司有权根据业务调整或法律法规要求修订本协议及附属文件，修订内容将通过软件首页公告或站内信公示，修订后的协议自公示之日起生效。若您在新版本生效后继续使用本软件，视为已接受修订后的协议；若您不同意修订内容，可停止使用本软件及相关服务。  
    </p>
    <p>
      3.协议可分性
    </p>
    <p>
      本协议部分条款无效或不可执行的，不影响其他条款效力，双方应协商替换为合法等效条款。  
    </p>
    <p>
      4.联系方式
    </p>
    <p>
      客服邮箱：dywlkj2023@163.com
    </p>
    <p>
      客服热线：13366011888
    </p>
    <p>
      收件地址：广东省广州市天河区林和西路9号1917房
    </p>
    <!-- <div class="actions">
      <button @click="agreePolicy">同意</button>
      <button @click="disagreePolicy">不同意</button>
    </div> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      updateDate: "2025年04月15日",
      effectiveDate: "2025年04月15日",
      contactEmail: "dywlkj2023@163.com",
      contactPhone: "13366011888",
      address: "广东省广州市天河区林和西路9号1917房",
    };
  },
  methods: {
    agreePolicy() {
      console.log("用户已同意隐私协议");
      this.$emit("agree");
    },
    disagreePolicy() {
      console.log("用户不同意隐私协议");
      this.$emit("disagree");
    },
  },
};
</script>

<style scoped>
.privacy-policy {
  overflow-y: scroll;
  width: 100vw;
  margin: 0 auto;
  padding: 20px;
  font-family: Arial, sans-serif;
  line-height: 1.6;
}

h1 {
  text-align: center;
  margin-bottom: 20px;
}

h2 {
  margin-top: 30px;
  margin-bottom: 15px;
}

h3 {
  margin-top: 20px;
  margin-bottom: 10px;
}

ul {
  margin-left: 20px;
  margin-bottom: 15px;
}

table {
  width: 100%;
  border-collapse: collapse;
  margin: 20px 0;
}

th,
td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
}

th {
  background-color: #f2f2f2;
}

.actions {
  margin-top: 30px;
  text-align: center;
}

button {
  padding: 10px 20px;
  margin: 0 10px;
  cursor: pointer;
}

button:first-child {
  background-color: #4caf50;
  color: white;
  border: none;
}

button:last-child {
  background-color: #f44336;
  color: white;
  border: none;
}
.update-date,
.effective-date {
  text-align: right;
}
</style>
